import { useState } from "react"
import { useTranslation } from "react-i18next"
import SignUpForm from "features/signUp/signUpForm"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import Callout from "@/components/callout/callout"
import Hint from "@/components/text/Hint"
import { Link } from "react-router-dom"
import LoginGoogleForm from "@/features/login/LoginGoogleForm"
import ToggleInput from "@/components/inputs/toggleInput"
import Form from "components/forms/form"

const SignUpPage = () => {

    const { t } = useTranslation()
    const [acceptedTerms, setAcceptedTerms] = useState(false)

    return (
        <>
            <PageTitle title={t('titleSignUp')} />
            <Section>
                <Callout type="info">{t('signUpInfo')}</Callout>
            </Section>
            <Section>
                <Form className="group" onSubmit={(e) => e.preventDefault()}>
                    <Section design="card">
                        <ToggleInput
                            label={t('signUpAcceptTerms')}
                            checked={acceptedTerms}
                            onChange={(e) => setAcceptedTerms(e.target.checked)}
                            required
                            wide
                        />
                        <p className="flex flex-row flex-wrap items-center gap-x-2 text-sm text-gray-600 max-w-none">
                            <Link className="underline" to="/privacy">{t("titlePrivacy")}</Link>
                            <Link className="underline" to="/terms">{t("titleTerms")}</Link>
                        </p>
                    </Section>
                </Form>
            </Section>
            <Section design="card-grid-large">
                <SignUpForm acceptedTerms={acceptedTerms} />
                <Section design="centered-x">
                    <SectionHeader>
                        <SectionHeaderTitle design="divider">
                            <h3>{t('titleOtherSignUpMethods')}</h3>
                        </SectionHeaderTitle>
                    </SectionHeader>
                    <Hint className="small text-center">{t('descriptionOtherSignUpMethods')}</Hint>
                    <LoginGoogleForm disabled={!acceptedTerms} />
                    {!acceptedTerms && <Hint className="small text-center">{t('errorAcceptTerms')}</Hint>}
                </Section>
            </Section>
        </>
    )
}

export default SignUpPage
